
























import { Component } from 'vue-property-decorator';
import { DepositAccountModule } from '@/store/Accounts/DepositAccountModule';
import { DepositAccountSettingsModule } from '@/store/Accounts/DepositAccountSettingsModule';
import Alert from '@/components/Shared/Alert.vue';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import AccountToolkitMenu from '@/components/Accounts/Shared/Toolkit/AccountToolkitMenu.vue';
import DepositCurrentAccountTabs from '@/components/Accounts/DepositAccounts/Tabs/DepositCurrentAccountTabs.vue';
import DepositSavingsAccountTabs from '@/components/Accounts/DepositAccounts/Tabs/DepositSavingsAccountTabs.vue';
import DepositFixedTermTabs from '@/components/Accounts/DepositAccounts/Tabs/DepositFixedTermTabs.vue';
import DepositNoticeAccountTabs from '@/components/Accounts/DepositAccounts/Tabs/DepositNoticeAccountTabs.vue';
import ProductSubType from '@/models/Products/ProductSubType';

@Component({ name: 'DepositAccount', components: { Alert, AccountToolkitMenu, DepositCurrentAccountTabs, DepositSavingsAccountTabs, DepositFixedTermTabs, DepositNoticeAccountTabs }, metaInfo: { title: 'Deposit Accounts' } })
export default class extends SaascadaVue {

    ProductSubType = ProductSubType;

    async beforeMount() {
        await DepositAccountModule.getDepositAccount(this.$route.params.id);
        await DepositAccountSettingsModule.getAccount(this.$route.params.id);
        await DepositAccountSettingsModule.getProductIssue();
    }

    get account() {
        return DepositAccountModule.depositAccount;
    }

    get loading() {
        return DepositAccountModule.loadingDepositAccount;
    }

}
